import { Badge } from 'antd'
import { useTranslation } from 'react-i18next'

import type { SupportTicket } from 'src/api/main'

import { normalizeTicketStatus, resolveStatusBadge } from '../../constants'

type Props = {
  ticket: SupportTicket
  className?: string
}

const STATUS_LABEL_KEYS: Record<string, string> = {
  OPEN: 'tickets.statuses.open',
  'IN PROGRESS': 'tickets.statuses.inProgress',
  PENDING: 'tickets.statuses.pending',
  SOLVED: 'tickets.statuses.solved',
  COMPLETED: 'tickets.statuses.completed'
}

export const StatusBadge = ({ ticket, className }: Props) => {
  const { t } = useTranslation()

  const labelKey = STATUS_LABEL_KEYS[normalizeTicketStatus(ticket.status)]

  return (
    <Badge
      className={className}
      status={resolveStatusBadge(ticket)}
      text={labelKey ? t(labelKey) : ticket.status}
    />
  )
}
